module.exports = "/images/adress-vector_desktop.svg?6b773c6e6ec19b91d112186a367d7dcf";